<ion-split-pane when="md" contentId="main-content">
  <ion-menu contentId="main-content" menuId="main-menu">
    <ion-content>
      <div ion-fixed>
        <ion-toolbar color="primary">
          <div class="logo-container">
            <ion-img class="header" src="/assets/logos/cmillonario-lightbg.svg"></ion-img>
          </div>
          <ion-buttons slot="end">
            <ion-menu-button>
              <ion-icon name="close"></ion-icon>
            </ion-menu-button>
          </ion-buttons>
        </ion-toolbar>
        <ion-menu-toggle auto-hide="false">
          <ion-item
            color="primary"
            lines="none"
            detail
            [routerDirection]="'root'"
            [routerLink]="isAuthenticated ? '/account/profile' : null"
            routerLinkActive="active"
            class="profile-item"
            (click)="!isAuthenticated && handleMenuNavigation('/account/profile', $event)"
          >
            <ion-icon class="profile-icon" name="person-circle" slot="start"></ion-icon>
            <ion-label>
              <ion-text color="light">
                <p *ngIf="isAuthenticated">
                  {{ username }} <br />
                  <small>{{ email }}</small>
                </p>
                <p *ngIf="!isAuthenticated">
                  Iniciar Sesión <br />
                  <small>Tap para acceder</small>
                </p>
              </ion-text>
            </ion-label>
          </ion-item>
        </ion-menu-toggle>

        <ion-list lines="full" class="ion-no-padding list">
          <ion-menu-toggle auto-hide="false">
            <ion-item [routerDirection]="'root'" routerLink="/home" routerLinkActive="active">
              <ion-icon color="primary" slot="start" name="home-outline"></ion-icon>
              <ion-label><span translate> Home </span></ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle *ngIf="!brandingService.isMidiadesuerte()" auto-hide="false">
            <ion-item
              [routerDirection]="'root'"
              [routerLink]="isAuthenticated ? '/casino' : null"
              routerLinkActive="active"
              (click)="!isAuthenticated && handleMenuNavigation('/casino', $event)"
            >
              <ion-icon color="primary" slot="start" name="game-controller-outline"></ion-icon>
              <ion-label><span translate> Casino | Casino Live </span></ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle *ngIf="!brandingService.isMidiadesuerte()" auto-hide="false">
            <ion-item
              [routerDirection]="'root'"
              [routerLink]="isAuthenticated ? '/book' : null"
              routerLinkActive="active"
              (click)="!isAuthenticated && handleMenuNavigation('/book', $event)"
            >
              <ion-icon color="primary" slot="start" name="american-football-outline"></ion-icon>
              <ion-label><span translate> SportsBook </span></ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle *ngIf="brandingService.isMidiadesuerte()" auto-hide="false">
            <ion-item [routerDirection]="'root'" routerLink="/games" routerLinkActive="active">
              <ion-icon color="primary" slot="start" name="dice-outline"></ion-icon>
              <ion-label><span translate> Productos </span></ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle *ngIf="brandingService.isMidiadesuerte()" auto-hide="false">
            <ion-item
              [routerDirection]="'root'"
              [routerLink]="isAuthenticated ? '/results' : null"
              (click)="!isAuthenticated && handleMenuNavigation('/results', $event)"
              routerLinkActive="active"
            >
              <ion-icon color="primary" slot="start" name="ribbon-outline"></ion-icon>
              <ion-label><span translate> Resultados </span></ion-label>
            </ion-item>
          </ion-menu-toggle>

          <ion-menu-toggle auto-hide="false">
            <ion-item
              [routerDirection]="'root'"
              [routerLink]="isAuthenticated ? '/wallet' : null"
              routerLinkActive="active"
              (click)="!isAuthenticated && handleMenuNavigation('/wallet', $event)"
            >
              <ion-icon color="primary" slot="start" name="wallet-outline"></ion-icon>
              <ion-label><span translate> Mis Wallets </span></ion-label>
            </ion-item>
            <ion-item [routerDirection]="'root'" routerLink="/purchase-history" routerLinkActive="active">
              <ion-icon color="primary" slot="start" name="ticket-outline"></ion-icon>
              <ion-label><span translate> Historial </span></ion-label>
            </ion-item>
            <ion-item
              [routerDirection]="'root'"
              [routerLink]="isAuthenticated ? '/wallet' : null"
              (click)="!isAuthenticated && handleMenuNavigation('/wallet', $event)"
            >
              <ion-icon color="primary" slot="start" name="gift-outline"></ion-icon>
              <ion-label><span translate> Cupones </span></ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle auto-hide="false">
            <ion-item
              button
              (click)="isAuthenticated ? openAddFundsModal() : handleMenuNavigation('/wallet', $event)"
              routerLinkActive="active"
            >
              <ion-icon color="primary" slot="start" name="cash-outline"></ion-icon>
              <ion-label><span translate> Cargar saldo </span></ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-menu-toggle auto-hide="false">
            <ion-item
              [routerDirection]="'root'"
              [routerLink]="isAuthenticated ? '/account/profile' : null"
              routerLinkActive="active"
              (click)="!isAuthenticated && handleMenuNavigation('/account/profile', $event)"
            >
              <ion-icon color="primary" slot="start" name="person-outline"></ion-icon>
              <ion-label><span translate> Perfil </span></ion-label>
            </ion-item>
          </ion-menu-toggle>

          <ion-item
            [routerDirection]="'root'"
            routerLink="/legal"
            [queryParams]="{ doc: 'terms' }"
            queryParamsHandling="merge"
            routerLinkActive="active"
            (click)="trackingPageInfo('page_visited', 'Terms and conditions')"
          >
            <ion-icon color="primary" slot="start" name="shield-checkmark-outline"></ion-icon>
            <ion-label><span translate> Términos y Condiciones </span></ion-label>
          </ion-item>

          <!-- 
            -->
          <ion-item
            (click)="trackingPageInfo('page_visited', 'Juego responsable')"
            [routerLink]="['/legal']"
            [queryParams]="{ doc: 'responsible' }"
            queryParamsHandling="merge"
            [routerDirection]="'root'"
            routerLinkActive="active"
          >
            <ion-icon color="primary" slot="start" name="hand-right-outline"></ion-icon>
            <ion-label><span translate> Juego Responsable </span></ion-label>
          </ion-item>
          <!-- <ion-menu-toggle auto-hide="false">
            <ion-item
              button
              (click)="isAuthenticated ? openZendesk() : handleMenuNavigation('/account/profile', $event)"
            >
              <ion-icon color="primary" slot="start" name="help-circle-outline"></ion-icon>

              <ion-label><span translate> Ayuda </span></ion-label>
            </ion-item>
          </ion-menu-toggle> -->
          <ion-menu-toggle auto-hide="false">
            <ion-item button (click)="openZendesk()">
              <ion-icon color="primary" slot="start" name="help-circle-outline"></ion-icon>
              <ion-label>
                <span translate> Ayuda </span>
              </ion-label>
            </ion-item>
          </ion-menu-toggle>

          <ion-menu-toggle auto-hide="false">
            <!-- <ion-item button (click)="rateUs()" routerLinkActive="active">
              <ion-icon color="primary" slot="start" name="star-outline"></ion-icon>
              <ion-label><span translate> Califícanos </span></ion-label>
            </ion-item> -->
            <!-- <ion-item [routerDirection]="'root'" routerLink="/about" routerLinkActive="active">
              <ion-icon color="primary" slot="start" name="notifications-outline"></ion-icon>
              <ion-label><span translate> Notificaciones </span></ion-label>
            </ion-item> -->
            <!--
            <ion-item [routerDirection]="'root'" routerLink="/about" routerLinkActive="active">
              <ion-icon color="primary" slot="start" name="headset-outline"></ion-icon>
              <ion-label
                ><span translate>
                  <ion-text color="primary"> Ayuda en linea </ion-text>
                </span></ion-label
              >
            </ion-item>
          -->
            <!-- <ion-item
              [routerDirection]="'root'"
              routerLink="/about"
              routerLinkActive="active"
              (click)="trackingPageInfo('page_visited', 'Tutorials')"
            >
              <ion-icon color="primary" slot="start" name="help-circle-outline"></ion-icon>
              <ion-label><span translate> Tutoriales </span></ion-label>
            </ion-item> -->
            <!--       <ion-item [routerDirection]="'root'" routerLink="/about" routerLinkActive="active">
              <ion-icon color="primary" slot="start" name="calendar-outline"></ion-icon>
              <ion-label><span translate> Programar </span></ion-label>
            </ion-item> -->

            <!-- 
            <ion-item
              [routerDirection]="'root'"
              routerLink="/about"
              routerLinkActive="active"
              (click)="trackingPageInfo('page_visited', 'share')"
            >
              <ion-icon color="primary" slot="start" name="share-social-outline"></ion-icon>
              <ion-label><span translate> Compartir </span></ion-label>
            </ion-item> -->
            <!--      <ion-item *ngIf="!isProd" button (click)="copyToken()" routerLinkActive="active" color="danger">
              <ion-icon slot="start" name="copy-outline"></ion-icon>
              <ion-label><span translate> Copy token </span></ion-label>
            </ion-item> -->
          </ion-menu-toggle>

          <div class="social-media">
            <div class="social-icons ion-text-center">
              <!-- <ion-icon name="logo-facebook" (click)="openLink('https://facebook.com/cmillonario')"></ion-icon>
              <ion-icon name="logo-instagram" (click)="openLink('https://www.instagram.com/tucmillonario/')"></ion-icon> -->
              <ion-icon name="mail-outline" (click)="openLink('mailto:atencion_clientes@cmillonario.mx')"></ion-icon>
              <ion-icon src="./assets/icons/pg18.svg" title="Disponible únicamente para mayores de edad"></ion-icon>
            </div>
          </div>
        </ion-list>
      </div>
    </ion-content>
  </ion-menu>
  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-split-pane>
